<!-- 文本输入框 -->
<template>
<div class="text">
    <div class="emoji">
          <!-- <i class="icon iconfont icon-look" @click="showEmoji=!showEmoji"></i>
          <transition name="showbox">
             <div class="emojiBox" v-show="showEmoji">
                 <li v-for="(item, index) in emojis" :key="index">
                    <img :src="'static/emoji/'+item.file" :data="item.code" @click="content +=item.code">
                 </li>
             </div>
          </transition> -->
    </div>
    <textarea ref="text" v-model="content" @keydown="onKeydown" @click="showEmoji=false"></textarea>
    <div class="send" @click="send">
    	<span>发送(ent)</span>
    </div>
    <!-- <transition name="appear">
	    <div class="warn" v-show="warn">
	    	<div class="description">不能发送空白信息</div>
	    </div>
	</transition> -->
</div>
</template>

<script>
import api from '../../api/api'
export default {
    props: {
        sessionId: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            content: '',
            reply: '未找到',
            frequency: 0,
            warn: false,
            showEmoji: false,
            emojis: [],
            sending: false // 发送状态标志，防止重复发送
        };
    },
    created() {

    },
    methods: {

        // 按回车发送信息，按Shift+Enter换行
        onKeydown(e) {
            // 按Enter键且未按Shift键时发送消息
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault(); // 阻止默认换行行为
                this.send();
            }
        },
        // 点击发送按钮发送信息
        send () {
            // 防止重复发送
            if (this.sending) return;
            
            // 检查内容是否为空或只包含空白字符
            const trimmedContent = this.content.trim();
            if(!trimmedContent){
                this.warn = true
                // 清空输入框
                this.content = ''
                // 保持输入框焦点，确保光标可见
                this.$nextTick(() => {
                    this.$refs.text.focus();
                })
                // 警告信息1秒后消失
                setTimeout(() => {
                    this.warn = false;
                  }, 1000)
               }else{
                this.sending = true; // 设置发送中状态
                //console.log(this.sessionId);
                //console.log(this.content);
                // 先发送用户消息，去除首尾换行符
                api.sendMessage(this.sessionId, trimmedContent, true).then(() => {
                    // 清空输入框
                    this.content = ''
                    // 通知父组件更新消息列表
                    this.$emit('message-sent', this.sessionId)
                    // 保持输入框焦点，确保光标可见
                    this.$nextTick(() => {
                        this.$refs.text.focus();
                    })
                }).finally(() => {
                    this.sending = false; // 发送完成后重置状态
                })
               }
        }
    },
    // 在进入的时候 聚焦输入框
    mounted() {
            this.$refs.text.focus()
    },
    watch: {
        // 在选择其它对话的时候 聚焦输入框
        sessionId() {
          setTimeout(() => {
            this.$refs.text.focus()
          }, 0)
        },
        // 当输入框中的值为空时 弹出提示  并在一秒后消失
        content() {
            if(this.content === ''){
                if( this.frequency === 0){
                  this.warn = true;
                  this.frequency++
                  setTimeout(() => {
                    this.warn = false;
                  }, 1000)
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.text {
    position: relative;
    height: 150px;
    background: #fff;
    .emoji {
        position: relative;
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        padding: 0 30px;
        box-sizing: border-box;
        color: #7c7c7c;
        .icon-look {
            cursor: pointer;
            &:hover {
                color: #1aad19;
            }
        }
        .emojiBox {
            position: absolute;
            display: flex;
            flex-wrap: wrap;
            top: -210px;
            left: -100px;
            width: 300px;
            height: 200px;
            padding: 5px;
            background-color: #fff;
            border: 1px solid #d1d1d1;
            border-radius: 2px;
            box-shadow: 0 1px 2px 1px #d1d1d1;
            &.showbox-enter-active, &.showbox-leave-active {
                transition: all .5s;
            }
            &.showbox-enter, &.showbox-leave-active {
                opacity: 0;
            }
        }
    }
    textarea {
        box-sizing: border-box;
        padding: 0 30px;
        height: 110px;
        width: 100%;
        border: none;
        outline: none;
        font-family: "Micrsofot Yahei";
        resize: none;
    }
    .send {
        position: absolute;
        bottom: 10px;
        right: 30px;
        width: 75px;
        height: 28px;
        line-height: 28px;
        box-sizing: border-box;
        text-align: center;
        border: 1px solid #e5e5e5;
        border-radius: 3px;
        background: #f5f5f5;
        font-size: 14px;
        color: #7c7c7c;
        &:hover {
            background: rgb(18,150,17);
            color: #fff;
        }
    }
    .warn {
         position: absolute;
         bottom: 50px;
         right: 10px;
         width: 110px;
         height: 30px;
         line-height: 30px;
         font-size: 12px;
         text-align: center;
         border: 1px solid #bdbdbd;
         border-radius: 4px;
         box-shadow: 0 1px 5px 1px #bdbdbd;
         &.appear-enter-active, &.appear-leave-active {
            transition: all 1s;
         }
         &.appear-enter, &.appear-leave-active {
            opacity: 0;
         }
         &:before {
            content: " ";
            position: absolute;
            top: 100%;
            right: 20px;
            border: 7px solid transparent;
            border-top-color: #fff;
            filter: drop-shadow(1px 3px 2px #bdbdbd);
         }
    }
}
</style>
